import React from 'react';
import { Route, Routes } from 'react-router';
import { NotFoundPage } from './Common';
import { BrowserRouter, Navigate } from 'react-router-dom';
import { Box, createTheme, styled, ThemeProvider } from '@mui/material';
import { ProvideAuth } from '../hooks';
import { LicenseInfo } from '@mui/x-license-pro';
import { ProvideSnackBar } from '../hooks/useSnackBar';
import WorkerTravelDetailsPage from './PushNotification/WorkerTravelDetailsPage';
import CompanyWorkerDetailsPage from './PushNotification/CompanyWorkerDetailsPage';
import { RedirectHandler } from './Layout/RedirectHandler';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import huLocale from 'date-fns/locale/hu';

const MUI_LICENSE_KEY = (window as any).MUI_LICENSE_KEY || 'not known';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const StyledApp = styled(Box)`
    background-image: url(/images/brb_logo_vertical_white.svg);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 40%;
    min-height: 100%;
    height: 100%;
`;

const theme = createTheme({
    palette: {
        primary: {
            main: '#42C4AB',
        },
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <StyledApp>
                <BrowserRouter>
                    <ProvideAuth>
                        <RedirectHandler>
                            <ProvideSnackBar>
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={huLocale}>
                                    <Routes>
                                        <Route path="/" element={<Navigate to={"/conductor"} />} />
                                        <Route path="/conductor" element={<WorkerTravelDetailsPage />} />
                                        <Route path="/hr" element={<CompanyWorkerDetailsPage />} />
                                        <Route path="/*" element={<NotFoundPage />} />
                                    </Routes>
                                </LocalizationProvider>
                            </ProvideSnackBar>
                        </RedirectHandler>
                    </ProvideAuth>
                </BrowserRouter>
            </StyledApp>
        </ThemeProvider>
    );
}

export default App;
